import { ActionsList } from "../models";


export const ACTIONS_MARKING_LIST: ActionsList[] = [
    {
        id: "registration",
        name: "Регистрация карточки",
        action: "MARKING_REGISTER_PRODUCTS"
      },
      {
        id: "trade",
        name: "Отправить данные товаров",
        action: "MARKING_SEND_PRODUCTS"
      },
      {
        id: "file",
        name: "Отправить файлы/фото",
        action: "MARKING_SEND_IMPORT_PRODUCTS_PHOTOS"
      },
      {
        id: "moderation",
        name: "Отправка на модерацию",
        action: "MARKING_SEND_TO_MODERATION"
      },
      {
        id: "get_xml",
        name: "Подписать и отравить",
        action: "MARKING_GET_PRODUCTS_XMLS"
      },
      {
        id: "delete",
        name: "Удалить выбраное",
        action: "MARKING_DELETE_IMPORT_PRODUCTS"
      },
];